export default "__VITE_ASSET__Cpi5BdLy__"